(function () {
  var SELECTOR = '[data-scroll-reveal]';

  function revealElement(el) {
    el.classList.add('is-revealed');
  }

  function init() {
    var elements = document.querySelectorAll(SELECTOR);
    if (!elements.length) return;

    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      elements.forEach(revealElement);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      elements.forEach(revealElement);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            revealElement(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
